"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToTop = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const streamline_icon_move_up_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-move-up-1.svg"));
const react_scroll_1 = require("react-scroll");
const StickyButton_1 = require("../elements/StickyButton/StickyButton");
const BackToTop = () => {
    return ((0, jsx_runtime_1.jsx)(StickyButton_1.StickyButton, { onClick: () => {
            react_scroll_1.animateScroll.scrollToTop();
            return false;
        }, shape: "circle", children: (0, jsx_runtime_1.jsx)(streamline_icon_move_up_1_svg_1.default, { width: 24, height: 24 }) }));
};
exports.BackToTop = BackToTop;
